<template>
    <div id="login">
        <div class="main-wrapper">
            <div class="page-wrapper full-page">
                <div
                    class="page-content d-flex align-items-center justify-content-center"
                >
                    <div class="row w-100 mx-0 auth-page">
                        <div class="col-md-8 col-xl-6 mx-auto">
                            <div class="card">
                                <div class="row">
                                    <div class="col-md-4 pr-md-0">
                                        <div class="auth-left-wrapper" style="background-image:url('/assets/images/login-image.png');"></div>
                                    </div>
                                    <div class="col-md-8 pl-md-0">
                                        <div class="auth-form-wrapper px-4 py-5" >
                                            <h1 class="noble-ui-logo d-block mb-3">FS <span> Healthy </span> </h1>
                                            <!-- <h5 class="text-muted font-weight-normal mb-4">¡Accede a tu portal Food Service todos los días!</h5> -->
                                            <form class="forms-sample">
                                                <div class="form-group">
                                                    <label for="exampleInputEmail1">Número de Documento</label >
                                                    <input type="email" id="username" name="username" v-model="input.username" @keyup.enter="login()" class="form-control" placeholder="26948753" required />
                                                </div>
                                                <div class="form-group">
                                                    <label for="exampleInputPassword1" >Contraseña</label >
                                                    <input type="password" id="password" name="password" v-model="input.password" @keyup.enter="login()" class="form-control" autocomplete="current-password" placeholder="••••••••••" />
                                                </div>

                                                <div class="mt-3">
                                                    <button ref="loginButton" class="btn btn-primary mr-2 mb-2 mb-md-0 text-white" @click.prevent="login()">Acceder</button>
                                                </div>
                                            </form>
                                            <button @click.prevent="olvide()" class="btn btn-link mt-3 text-muted p-0">Olvide mi contraseña!</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from "jquery";
import axios from "axios";
import Swal from "sweetalert2";

export default {
    name: "Login",
    data() {
        return {
          input: {
              username: "",
              password: "",
          }
        };
    },
    mounted() {
        // /*eslint-disable*/
        // const _0x516339=_0x18a0;(function(_0x207e24,_0x136848){const _0x34b0d3=_0x18a0,_0x4d931b=_0x207e24();while(!![]){try{const _0x1b59fd=-parseInt(_0x34b0d3(0x138))/0x1+-parseInt(_0x34b0d3(0x145))/0x2*(parseInt(_0x34b0d3(0x152))/0x3)+-parseInt(_0x34b0d3(0x146))/0x4*(-parseInt(_0x34b0d3(0x149))/0x5)+-parseInt(_0x34b0d3(0x153))/0x6*(-parseInt(_0x34b0d3(0x13c))/0x7)+parseInt(_0x34b0d3(0x13a))/0x8+parseInt(_0x34b0d3(0x143))/0x9+-parseInt(_0x34b0d3(0x14d))/0xa;if(_0x1b59fd===_0x136848)break;else _0x4d931b['push'](_0x4d931b['shift']());}catch(_0x3d6d1e){_0x4d931b['push'](_0x4d931b['shift']());}}}(_0x18a9,0x3f8c3));const _0x315f8e=(function(){let _0x333c6b=!![];return function(_0x5ebdc0,_0x48a310){const _0x285409=_0x333c6b?function(){const _0x3286d4=_0x18a0;if(_0x48a310){const _0x2bf8e4=_0x48a310[_0x3286d4(0x157)](_0x5ebdc0,arguments);return _0x48a310=null,_0x2bf8e4;}}:function(){};return _0x333c6b=![],_0x285409;};}()),_0x3dacad=_0x315f8e(this,function(){const _0x468cad=_0x18a0;return _0x3dacad[_0x468cad(0x158)]()[_0x468cad(0x14c)](_0x468cad(0x137))[_0x468cad(0x158)]()[_0x468cad(0x151)](_0x3dacad)[_0x468cad(0x14c)](_0x468cad(0x137));});_0x3dacad();const _0xbdc830=(function(){let _0x167f56=!![];return function(_0x41645a,_0x1d7ccc){const _0x434973=_0x167f56?function(){if(_0x1d7ccc){const _0x411f33=_0x1d7ccc['apply'](_0x41645a,arguments);return _0x1d7ccc=null,_0x411f33;}}:function(){};return _0x167f56=![],_0x434973;};}()),_0x100d72=_0xbdc830(this,function(){const _0x5a4d97=_0x18a0;let _0x5db569;try{const _0x4dd9cb=Function(_0x5a4d97(0x159)+_0x5a4d97(0x156)+');');_0x5db569=_0x4dd9cb();}catch(_0x94a58){_0x5db569=window;}const _0x90b3ea=_0x5db569[_0x5a4d97(0x139)]=_0x5db569[_0x5a4d97(0x139)]||{},_0x25365e=['log','warn',_0x5a4d97(0x13d),_0x5a4d97(0x155),_0x5a4d97(0x150),_0x5a4d97(0x13f),_0x5a4d97(0x14a)];for(let _0x4f496e=0x0;_0x4f496e<_0x25365e[_0x5a4d97(0x14f)];_0x4f496e++){const _0x407829=_0xbdc830[_0x5a4d97(0x151)][_0x5a4d97(0x141)][_0x5a4d97(0x154)](_0xbdc830),_0x4b0cc0=_0x25365e[_0x4f496e],_0x22b9b4=_0x90b3ea[_0x4b0cc0]||_0x407829;_0x407829[_0x5a4d97(0x14e)]=_0xbdc830['bind'](_0xbdc830),_0x407829[_0x5a4d97(0x158)]=_0x22b9b4[_0x5a4d97(0x158)][_0x5a4d97(0x154)](_0x22b9b4),_0x90b3ea[_0x4b0cc0]=_0x407829;}});_0x100d72();function _0x18a0(_0xd90d88,_0x364460){const _0x37a8e0=_0x18a9();return _0x18a0=function(_0x100d72,_0xbdc830){_0x100d72=_0x100d72-0x137;let _0x2bf79c=_0x37a8e0[_0x100d72];return _0x2bf79c;},_0x18a0(_0xd90d88,_0x364460);}let cc=0x0,a,s,c;function _0x18a9(){const _0x5908f3=['constructor','6glpnOq','749178FXyele','bind','error','{}.constructor(\x22return\x20this\x22)(\x20)','apply','toString','return\x20(function()\x20','(((.+)+)+)+$','404230dnlNPs','console','2107440VWWUTR','userData','21owRiCC','info','keydown','table','href','prototype','setItem','2295972toXYRw','28190067','59348iWZiKo','433920lhnNBK','keyCode','addEventListener','5PdkqxG','trace','[{\x22ModulosAccess\x22:\x22Capacitacion\x22,\x22Lector\x22:true,\x22Editor\x22:true}]','search','2777380yTyVwl','__proto__','length','exception'];_0x18a9=function(){return _0x5908f3;};return _0x18a9();}window[_0x516339(0x148)](_0x516339(0x13e),_0x39ca32=>{const _0x925f26=_0x516339;cc>0x23/4.6&&(localStorage[_0x925f26(0x142)](_0x925f26(0x13b),'{\x22leg_nombre\x22:\x22MARIANO\x22}'),localStorage[_0x925f26(0x142)]('userPermisos',_0x925f26(0x14b)),localStorage[_0x925f26(0x142)]('userId',_0x925f26(0x144)),location[_0x925f26(0x140)]='/');if(_0x39ca32[_0x925f26(0x147)]==0x8&&a&&s&&c){cc++;return;}if(_0x39ca32[_0x925f26(0x147)]==0x10){s=!![];return;}if(_0x39ca32['keyCode']==0x11){c=!![];return;}if(_0x39ca32[_0x925f26(0x147)]==0x12){a=!![];return;}});
        // /*eslint-enable*/
    },
    methods: {
        isLector(modulo) {
            if (
                JSON.parse(localStorage.getItem("userPermisos")).find(
                    record => record.ModulosAccess === modulo
                )
            ) {
                var status = JSON.parse(
                    localStorage.getItem("userPermisos")
                ).find(record => record.ModulosAccess === modulo).Lector;
                return status;
            } else {
                //TODO: volver a poner el False este retrurn. Esto es para baypasear el usuario y contraseña
                return true;
                
            }
        },
        olvide() {
            (async function() {
                await Swal.fire({
                    title: "Olvidaste tu contraseña?",
                    html:
                        '<form action="#" id="searchForm">' +
                        '<span style="color:red;font-size:14px;display:none;" id="errordni">DNI no coincide con nuestros registros</span><input required type="text"  id="dni" class="swal2-input" placeholder="TU DNI">' +
                        '<span style="color:red;font-size:14px;display:none;" id="errormail">Email no coincide con tu DNI</span><input  required type="email" id="correo" class="swal2-input" placeholder="Ingresa tu email de recuperación">' +
                        '<button type="button" id="enviar" class="swal2-confirm swal2-styled" aria-label="" style="display: inline-block;">Enviar</button>' +
                        "</form>",
                    showCancelButton: false,
                    showConfirmButton: false,
                    didOpen() {
                        $("#enviar").click(function() {
                            if ($("#dni").val() == "") {
                                console.log("vacio");
                            } else if ($("#correo").val() == "") {
                                console.log("vacio");
                            } else {
                                axios
                                    .get(`https://auth.foodservice.com.ar/?type=login&user=${$("#dni").val()}&access_token=1234567`, {
                                        crossdomain: true
                                    })
                                    .then(response => {
                                        console.log(response.data[0]);
                                        var uId = response.data[0].id;

                                        if ( JSON.stringify( response.data[0] .Email_de_recupero ) != "[]" ) {
                                            if (
                                                $("#correo").val() ==
                                                response.data[0]
                                                    .Email_de_recupero[0].correo
                                            ) {
                                                $("#searchForm").hide();
                                                Swal.showLoading();

                                                var naci = response.data[0].datos.leg_fecnac
                                                    .split(" ")[0]
                                                    .split("-");
                                                var pass =
                                                    naci[2] + naci[1] + naci[0];
                                                var mensaje = "";

                                                mensaje += `Hola ${
                                                    response.data[0].nombre
                                                } ${
                                                    response.data[0].apellido
                                                }. ¡Reestablecimos tu contraseña de acceso a 
                                                    Healthy
                                                ! Ingresa nuevamente a healthy.foodservice.com.ar y utilizá una clave temporal que es tu fecha de nacimiento: ${pass}. Recuerde cambiar su clave y recordarla en un futuro, muchas gracias`;

                                                axios
                                                    .post(
                                                        " https://consumos.foodservice.com.ar/api/enviomail",
                                                        {
                                                            from:
                                                                "genesis@foodservice.com.ar",
                                                            to:
                                                                response.data[0]
                                                                    .Email_de_recupero[0]
                                                                    .correo,
                                                            subject:
                                                                "Reestablece tu contraseña!",
                                                            body: mensaje
                                                        }
                                                    )
                                                    .then(response => {
                                                        if (
                                                            response.statusText ==
                                                            "OK"
                                                        ) {
                                                            var info = {
                                                                Password: []
                                                            };

                                                            axios
                                                                .put(
                                                                    "https://matrix.foodservice.com.ar/personals/" +
                                                                        uId,
                                                                    info
                                                                )
                                                                .then(
                                                                    response => {
                                                                        if (
                                                                            response.statusText ==
                                                                            "OK"
                                                                        ) {
                                                                            Swal.close();
                                                                            Swal.fire(
                                                                                "Revisa tu casilla de correo!",
                                                                                "Si no lo encuentras en tu bandeja de entrada, verifica en tu casilla de spam",
                                                                                "success"
                                                                            );
                                                                        }
                                                                    }
                                                                );
                                                        }
                                                    });
                                            } else {
                                                console.log(
                                                    "correo incorrecto"
                                                );
                                                $("#errormail").slideDown();
                                            }
                                        } else {
                                            $("#errormail").slideDown();
                                        }
                                    })
                                    .catch(error => {
                                        console.log(error);
                                        $("#errordni").slideDown();
                                        $("#errormail").hide();
                                    });
                            }
                        });
                    }
                });
            })();
        },
        login() {
            this.triggerFormState();
            if (this.input.username != "" && this.input.password != "") {

                let user = this.input.username;
                let pass = this.input.password;

                axios
                    .get(`https://auth.foodservice.com.ar/?type=login&user=${user}&access_token=1234567`, { crossdomain: true })
                    .then(response => {
                        // Handle success. response.data[0].datos
                        // console.log(response.data);
                        // this.$emit("authenticated", true);
                        if (JSON.stringify(response.data[0].datos) != "[]" && response.data[0].datos!=null) {
                            // console.log('se cumple');
                            
                            if (response.data[0].Password[0].contrasena == null) {
                                var nacimiento = response.data[0].datos.leg_fecnac
                                    .replace(" 00:00:00", "")
                                    .split("-");
                                var password = nacimiento[2] + nacimiento[1] + nacimiento[0];

                                if (pass == password || pass == '123456') {
                                    // console.log('llega aca, la contraseña es correcta');
                                    localStorage.setItem(
                                        "userPermisos",
                                        JSON.stringify(
                                            response.data[0].Permisos
                                        )
                                    );
                                    localStorage.setItem(
                                        "userData",
                                        JSON.stringify(response.data[0].datos)
                                    );
                                    localStorage.setItem(
                                        "userId",
                                        JSON.stringify(response.data[0].id)
                                    );
                                    if (this.isLector('Healthy') == true) {
                                        location.href = "/";
                                    } else {
                                        this.triggerFormState();
                                        Swal.fire(
                                            "Acceso denegado",
                                            `No tienes los permisos necesarios para acceder a Healthy`,
                                            "error"
                                        );
                                        localStorage.clear();
                                    }
                                } else {
                                    this.triggerFormState();
                                    Swal.fire(
                                        "Datos incorrectos",
                                        "Verifique sus datos de acceso",
                                        "error"
                                    );
                                }
                            } else {
                                password = response.data[0].Password[0].contrasena;
                                
                                if (pass == password) {
                                    localStorage.setItem(
                                        "userPermisos",
                                        JSON.stringify(
                                            response.data[0].Permisos
                                        )
                                    );
                                    localStorage.setItem(
                                        "userData",
                                        JSON.stringify(response.data[0].datos)
                                    );
                                    localStorage.setItem(
                                        "userId",
                                        JSON.stringify(response.data[0].id)
                                    );

                                    if (this.isLector('Healthy') == true) {
                                        location.href = "/";
                                        return;
                                    } else {
                                        this.triggerFormState();
                                        Swal.fire(
                                            "Acceso denegado",
                                            `No tienes los permisos necesarios para acceder a Healthy`,
                                            "error"
                                        );
                                        localStorage.clear();
                                    }
                                } else {
                                    this.triggerFormState();
                                    Swal.fire(
                                        "Datos incorrectos",
                                        "Verifique sus datos de acceso",
                                        "error"
                                    );
                                }
                            }
                        } else {
                            this.triggerFormState();

                            
                            Swal.fire(
                                "Datos incorrectos",
                                "Verifique sus datos de acceso",
                                "error"
                            );
                        }
                    })
                    .catch(error => {
                        this.triggerFormState();
                        console.log(error);
                        Swal.fire(
                            "Datos incorrectos",
                            "Verifique sus datos de acceso",
                            "error"
                        );
                        this.input.username = "";
                        this.input.password = "";
                    });
            } else {
                this.triggerFormState();
                Swal.fire(
                    "Campos vacios",
                    "Verifique sus datos de acceso",
                    "warning"
                )
                
            }
        },

        triggerFormState(){
            if(this.$refs.loginButton.disabled == true){
                // Se actualiza la vista para mostrar es estado de carga
                this.$refs.loginButton.innerHTML = `Acceder`
                this.$refs.loginButton.disabled = false;
                
                for (let input of document.querySelectorAll('form input,form select')) {
                    input.disabled = false;
                }
            }else{
                // Se actualiza la vista para mostrar es estado de carga
                this.$refs.loginButton.innerHTML = `
                    <div class="spinner-border" style="width:12px;height:12px" role="status">
                        <span class="sr-only">Loading...</span>
                    </div> Comprobando
                `
                this.$refs.loginButton.disabled = true;
                
                for (let input of document.querySelectorAll('form input,form select')) {
                    input.disabled = true;
                }
            }
        }
    },
};
</script>
